/* 登录失效后，判断当前环境跳转对应页面 */
import { Dialog } from 'vant'

declare global {
  interface Window {
    [key: string]: any
  }
}

/** 优先走 Flutter 新容器，没有再回退原生桥，避免 H5 无法区分新老版本 */
function callAppCheckLogin(nativeCall: () => void) {
  if (window.flutter_inappwebview?.callHandler) {
    window.flutter_inappwebview.callHandler('checkLogin')
    return
  }
  nativeCall()
}

//判断当前环境
const options = {
  android: () => {
    console.log('当前是===安卓环境')
    callAppCheckLogin(() => window.pukangbao?.checkLogin())
  },
  ios: () => {
    console.log('当前是===ios环境')
    callAppCheckLogin(() => window.webkit?.messageHandlers?.checkLogin?.postMessage(''))
  },
  wechat: () => {
    console.log('当前是===微信小程序环境')
    window.wx.miniProgram.redirectTo({ url: '/pages/login/login' })
  },
  harmonyOS: () => {
    console.log('当前是===鸿蒙环境')
    window.flutter_inappwebview.callHandler('checkLogin')
  },
  H5: () => {
    console.log('当前是===h5环境')
    const path = process.env.VUE_APP_IMAGE_URL_PATH + '/pkbwx/router-dispatcher'
    window.location.href = path
  }
}

export function getCurrentEnv() {
  // 存在clientId表示从app/小程序/公众号进入,没有的情况下不处理还是走老逻辑
  const clientId = sessionStorage.getItem('clientId') || ''
  if (!clientId || clientId === 'null' || clientId === 'undefined') {
    return false
  }
  try {
    const ua = navigator.userAgent.toLowerCase()
    const terminal = sessionStorage.getItem('terminal')
    // 公众号terminal=27
    const isH5 =  /micromessenger/i.test(ua) && terminal === '27'
    const isAndroid = /android/i.test(navigator.userAgent) && !isH5
    const isIOS = /iphone|ipad|ipod/i.test(navigator.userAgent) && !isH5
    const isHarmonyOS = ua.includes('harmony') || ua.includes('hmos') || /huawei/i.test(ua) && !isH5
    //进一步判断是否是微信小程序
    const isWechat = typeof window.wx !== "undefined" && window.wx.miniProgram && window.__wxjs_environment === "miniprogram"
    console.log('当前环境：','安卓：', isAndroid, 'ios：', isIOS, '微信：', isWechat, '鸿蒙：', isHarmonyOS, 'h5：', isH5)

    if (isH5 && !isWechat) {
      return 'H5'
    }
    if (isWechat) {
      return 'wechat'
    }
    if (isAndroid) {
      return 'android'
    }
    if(isIOS) {
      return 'ios'
    }
    if(isHarmonyOS) {
      return 'harmonyOS'
    }
    return false
  } catch (e) {
    console.log('获取当前环境失败', e)
    return false
  }
}

export function envBackHandler() {
  const isEnv = getCurrentEnv()
  Dialog.alert({
    message: '您的账号信息已失效，需要重新登录',
    confirmButtonText: "我知道了",
  }).then(() => {
    if (isEnv) {
      options[isEnv] && options[isEnv]()
    }
  })
 }